import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';

import {AuthService} from '../../auth/auth.service';

@Injectable()
export class JwtTokenInterceptor implements HttpInterceptor {

  constructor(private authService: AuthService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if(this.authService.isLoggedIn()) {
      let token = this.authService.getIdToken();
      if(token && token.length > 0) {
        const jwtReq = request.clone({
          headers: request.headers.set('Authorization', "Bearer " + token)
        });

        return next.handle(jwtReq);
      }
    }
    return next.handle(request);
  }
}
